/**
 * Player configuration.
 *
 * In production, these values are injected at build time via environment
 * variables (VITE_*). For local development, defaults point to the dev
 * MediaTailor playback URL.
 */

export interface PlayerConfig {
  /** MediaTailor session-initialized playback URL */
  playbackUrl: string;
  /** Session API endpoint for getting signed playback URLs */
  sessionApiUrl: string;
  /** WebSocket endpoint for viewer count */
  wsViewerCountUrl: string;
  /** WebSocket endpoint for reactions */
  wsReactionUrl: string;
  /** WebSocket endpoint for ad break metadata */
  wsAdBreakUrl: string;
  /** Channel ID for WebSocket connections */
  channelId: string;
  /** Token for WebSocket authentication */
  wsToken: string;
  /** Customer logo asset URL */
  logoUrl: string;
  /** Player locale */
  locale: 'fr' | 'en' | 'pt';
  /** Theme preference */
  theme: 'light' | 'dark' | 'auto';
}

export interface CatchUpConfig {
  /** Segment duration in seconds */
  segmentDuration: number;
  /** Maximum acceptable delay before catch-up triggers (2x segment) */
  maxDelay: number;
  /** Playback speed during catch-up */
  catchUpSpeed: number;
  /** Threshold to resume normal speed (1x segment) */
  resumeThreshold: number;
}

export const catchUpConfig: CatchUpConfig = {
  segmentDuration: 1.92,
  maxDelay: 3.84,
  catchUpSpeed: 1.4,
  resumeThreshold: 1.92,
};

export const playerConfig: PlayerConfig = {
  playbackUrl: import.meta.env.VITE_PLAYBACK_URL || '',
  sessionApiUrl: import.meta.env.VITE_SESSION_API_URL || '',
  wsViewerCountUrl: import.meta.env.VITE_WS_VIEWER_COUNT_URL || '',
  wsReactionUrl: import.meta.env.VITE_WS_REACTION_URL || '',
  wsAdBreakUrl: import.meta.env.VITE_WS_AD_BREAK_URL || '',
  channelId: import.meta.env.VITE_CHANNEL_ID || 'capoeira-dev',
  wsToken: import.meta.env.VITE_WS_TOKEN || 'dev-token',
  logoUrl: import.meta.env.VITE_LOGO_URL || '/logo.png',
  locale: (import.meta.env.VITE_LOCALE as PlayerConfig['locale']) || 'fr',
  theme: (import.meta.env.VITE_THEME as PlayerConfig['theme']) || 'auto',
};
